import { Component } from 'react';
import { connect } from 'react-redux';

import AmazonAffiliatesGiftLink from '../../common/components/amazon-affiliates-gift-link';
import RouterLink from "../../common/components/router-link";
import RsvpResponseButtons from './rsvp-response-buttons'
import MobileInvitationDesign from './mobile-invitation-design'
import * as actions from '../actions';
import * as utils from '../../utils';
import urls from '~/common/urls';
import { EviteModal } from '../../../modal/index'


class RsvpTab extends Component {
  render() {
    const isMobile = utils.isMobile();
    return (
      <div className="rsvp-panel">
        { isMobile &&
          <MobileInvitationDesign />
        }
        <div className="simple-shadowbox rsvp-form-container">
          <RsvpBlock />
          <AmazonAffiliatesGiftLink compactVersion />
        </div>
        <EventActions />
        <FromHostPanel
          hasPoll={this.props.hasPoll}
          hasWhatToBring={this.props.hasWhatToBring}
        />
      </div>
    );
  }
}

class RsvpBlock extends Component {
  constructor(props) {
    super(props);
    this.toggleChangeRsvpVisible = this.toggleChangeRsvpVisible.bind(this);
    this.state = {
      validationErrors: {},
    };
  }

  render() {
    if (this.props.showChangeRsvp || !utils.hasRsvpd()) {
      if (utils.isCancelled()) {
        return (
          <h3 className="feed-notice">
            RSVP closed - this event has been canceled
          </h3>
        );
      }
      if (utils.eventHasPassed()) {
        return (
          <h3 className="feed-notice">
            RSVP closed - this event has already occurred
          </h3>
        );
      }
      if (utils.isPreview()) {
        return (
          <h3 className="feed-notice">
            RSVP closed in preview mode
          </h3>
        );
      }
      return (
        <div className="rsvp-form-wrap-new">
          <h1>
            Will you attend?
          </h1>
          { this.props.hasRsvpd &&
            <a href="#" onClick={this.toggleChangeRsvpVisible} className="cancel-rsvp-form">Cancel</a>
          }
          <RsvpResponseButtons
            rsvpResponse={this.props.rsvpResponse}
            formSubmitting={this.props.formSubmitting}
          />
        </div>
      );
    }

    return (
      <div className="rsvp-form-wrap you-replied">
        <h1>
          You replied
          <span className={this.props.rsvpResponse}>
            &nbsp;{this.props.rsvpResponse}
          </span>
          { !this.props.preventRsvp &&
            <a href="#" className="link-style small" onClick={this.toggleChangeRsvpVisible}>
              Change Reply
            </a>
          }
        </h1>
      </div>
    );
  }

  toggleChangeRsvpVisible = (e) => {
    e.preventDefault();
    actions.toggleChangeRsvpVisible();
  }
}

class EventActions extends Component{
  shouldComponentUpdate() {
    return false;
  }

  printUrl () {
    if (window.is_premium) {
      return urls.get('print_event_premium', {
        event_id: window.evite_event.id,
        guest_id: window.guest_id
      });
    }
    return urls.get('print_event', {
      event_id: window.evite_event.id

    });
  }

  render() {
    const eviteEvent = window.evite_event;
    const showMap = (eviteEvent.street_address || eviteEvent.city || eviteEvent.state || eviteEvent.zip_code);
    const mapUrl = urls.get('event_map_redirect', {
        event_id: eviteEvent.id,
        guest_id: window.guest_id
      });

    if(utils.isMobile()){
      return (
        <div className="event-actions">
          { utils.hasRsvpd() && evite.features.isEnabled('add-to-calendar') &&
          <AddToCalendar data-source="invite"/>
          }
        </div>
      );
    }

    return (
      <div className="event-actions">
        { showMap &&
          <a href={mapUrl} target="_blank">
            <i className="icon-map"></i> View Map
          </a>
        }
        <a href={ this.printUrl() } target="_blank">
          <i className="icon-print"></i> Print Invitation
        </a>
        { utils.hasRsvpd() && evite.features.isEnabled('add-to-calendar') &&
          <AddToCalendar data-source="invite" />
        }
      </div>
    );
  }
}


class FromHostPanel extends Component {
  shouldComponentUpdate(nextProps, nextState) {
    return false;
  }

  render() {
    const { hasPoll, hasWhatToBring } = this.props;
    const hasDonate = window.donations_enabled;
    const hasRegistry = Array.isArray(window.evite_event.registries) && window.evite_event.registries.length;
    const hasWishlist = window.wishlist_enabled;
    const hasAddedItems = hasPoll || hasWhatToBring || hasRegistry || hasWishlist || hasDonate;
    const registryIconClassName = "icon-registry_" + window.gift_registry_provider;
    if (window.host_message || hasAddedItems) {
      return (
        <div className="simple-shadowbox from-host-panel">
          { window.host_message &&
            <HostMessage />
          }
          { hasAddedItems &&
            <div className="host-panel host-has-added">
              <h3>Your host has added:</h3>
              <ul>
                { hasPoll &&
                  <li>
                    <RouterLink
                      to={utils.eventTabUrlPath("polls")}
                      trackingSrc="rsvp-host-panel"
                    >
                      <i className="icon-polls"></i> Poll
                    </RouterLink>
                  </li>
                }
                { hasWhatToBring &&
                  <li>
                    <RouterLink
                      to={utils.eventTabUrlPath("what-to-bring")}
                      trackingSrc="rsvp-host-panel"
                    >
                      <i className="icon-wtb"></i> What To Bring
                    </RouterLink>
                  </li>
                }
                { hasRegistry && !hasWishlist &&
                  <li>
                    <RouterLink
                      to={utils.eventTabUrlPath("gifts")}
                      trackingSrc="rsvp-host-panel"
                    >
                      <i className={registryIconClassName}></i> Registry
                    </RouterLink>
                  </li>
                }
                { hasWishlist && !hasRegistry &&
                  <li>
                    <RouterLink
                      to={utils.eventTabUrlPath("gifts")}
                      trackingSrc="rsvp-host-panel"
                    >
                      <i className="icon-wishlist"></i> Wish List
                    </RouterLink>
                  </li>
                }
                { hasDonate &&
                  <li>
                    <RouterLink
                      to={utils.eventTabUrlPath("donate")}
                      trackingSrc="rsvp-host-panel"
                    >
                      <i className="icon-donations"></i> Donate
                    </RouterLink>
                  </li>
                }
              </ul>
            </div>
          }
        </div>
      )
    }
    return null;
  }
}


class HostMessage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      minimized: false,
      heightThreshold: utils.isMobile() ? 400 : 900
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return this.state.minimized !== nextState.minimized;
  }

  componentDidMount() {
    if (this.hostMessageWrapper && this.hostMessageWrapper.offsetHeight > this.state.heightThreshold) {
      this.setState({minimized: true});
    }
  }

  render() {
    const hostMessage = window.host_message;
    const isMinimized = this.state.minimized;
    return (
      <div
        className={`message-from-host ${isMinimized ? "minimized" : ""}`}
        style={isMinimized ? { maxHeight: this.state.heightThreshold + "px" } : {}}
        ref={(c) => this.hostMessageWrapper = c}
        id="host-message"
      >
        { !window.is_premium &&
          <h3>Message from Host</h3>
        }

        <div dangerouslySetInnerHTML={{__html: hostMessage}} />
        { isMinimized &&
          <div className="message-from-host-overlay">
            <button
              className="button-primary-inverse small"
              onClick={this.handleShowMoreClick}
            >
              Show more
            </button>
          </div>
        }
      </div>
    )
  }
  handleShowMoreClick = (e) => {
    e.preventDefault();
    this.setState({minimized: false});
  };
}

class AddToCalendar extends Component {
  render() {
    let text = this.props.text || this.props.title;

    return (
      <a
        id="add-to-calendar"
        className={this.props.className}
        href='javascript:void(0)'
        title={this.props.title}
        data-type={this.props['data-type']}
        data-source={this.props['data-source']}
        data-action={this.props['data-action']}
        onClick={this.handleClick}
      >
        <i className="icon-calendar-plus"></i>
        {text}
      </a>
    );
  }

  handleClick = (event) => {
    event.preventDefault();

    const isMobile = utils.isMobile();
    if(isMobile) {
      this.downloadCalendarEvent();
    } else {
      const addToCalendarModal = this.createAddToCalendarModal();
      addToCalendarModal.show();
    }

    return false;
  };

  downloadCalendarEvent(){
    location.href = `${ location.origin }/event/${ window.event_id }/export/ical/?gid=${ window.guest_id }`;
  }

  createAddToCalendarModal(){
    const isMobile = utils.isMobile();

    return new EviteModal({
      width: '640px',
      url: urls.get('modal_add_to_calendar', {
          event_id: window.evite_event.id
        }),
        url_parameters: {
          guest_id: window.guest_id,
          is_mobile: utils.isMobile()
        }
      });
  }
}


AddToCalendar.defaultProps = {
  className: '',
  text: '',
  title: 'Add to Calendar',
  'data-action': 'download',
  'data-source': '',
  'data-type': 'calendar',
};


function mapRsvpToProps(state) {
  return state.rsvp;
}
RsvpBlock = connect(mapRsvpToProps)(RsvpBlock);


function mapStateToProps(state) {
  return {
    hasPoll: state.polls.length > 0,
    hasWhatToBring: state.whattobring.creator_id,
    rsvp: state.rsvp,
  };
}



RsvpTab = connect(mapStateToProps)(RsvpTab);

export { RsvpTab };
export default RsvpTab;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/rsvp/components/rsvp-tab.es6